import type { Metric } from 'web-vitals'
import { appLogger } from '@/utils/logger'

let webVitalsStarted = false

const reportMetric = (metric: Metric): void => {
  appLogger.info('Web Vitals metric', {
    name: metric.name,
    value: Number(metric.value.toFixed(2)),
    rating: metric.rating,
    id: metric.id,
    navigationType: metric.navigationType,
  })
}

export const startWebVitalsMonitoring = (): void => {
  if (webVitalsStarted || typeof window === 'undefined') {
    return
  }

  webVitalsStarted = true

  void import('web-vitals')
    .then(({ onCLS, onFCP, onINP, onLCP, onTTFB }) => {
      onCLS(reportMetric)
      onFCP(reportMetric)
      onINP(reportMetric)
      onLCP(reportMetric)
      onTTFB(reportMetric)
    })
    .catch((error: unknown) => {
      appLogger.warn('Failed to initialize web-vitals', error)
    })
}
